import { animate, AnimationTriggerMetadata, keyframes, style, transition, trigger } from "@angular/animations";


export const showExpiracionClaveAnimation: AnimationTriggerMetadata =
	trigger('smoothShow', [
		transition( ':enter', [
			animate( '500ms ease', keyframes([
				style( { transform: 'skewX(-53deg) translateX(100%)', offset: 0 } ),
				style( { transform: 'translateX(0)', offset: .6 } ),
				style( { transform: 'skewX(0) translateX(-15%)', offset: .62 } ),
				style( { transform: 'skewX(20deg)', offset: .7 } ),
				style( { transform: 'skewX(0) translateX(0)', offset: .8 } ),
				style( { transform: 'skewX(5deg)', offset: .9 } ),
				style( { transform: 'skewX(0) translateX(0)', offset: 1 } )
			]))
		]),
		transition( ':leave', [
			animate( '300ms ease', keyframes([
				style( { opacity: '1', offset: 0 } ),
				style( { opacity: '0', offset: 1 } )
			]))
		])
	]);
